
import WebFont from 'webfontloader'

const options = {"google":{"families":["Montserrat:400,500,600,700,800","Noto+Sans+JP:400,500,600,700,800"]}}

WebFont.load(options)
